import { render, staticRenderFns } from "./AppointmentCard.vue?vue&type=template&id=593610a9&scoped=true&"
import script from "./AppointmentCard.vue?vue&type=script&lang=js&"
export * from "./AppointmentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593610a9",
  null
  
)

export default component.exports